import { ProtocolImage } from '@/components/common/protocolImage'
import { Tooltip, TooltipContent } from '@/components/common/tooltip'
import type { BorrowMarket } from '@/utils/internalAppSdk'
import { getProtocolDisplayName } from '@/utils/protocol'

interface Props {
  protocol: BorrowMarket['protocol']
  className?: string
}

export const BorrowMarketProtocolTooltip = ({ protocol, className }: Props) => {
  const protocolDisplayName = getProtocolDisplayName(protocol)

  return (
    <Tooltip tabIndex={-1} className="relative z-[1]">
      <ProtocolImage protocol={protocol} className={className} />
      <TooltipContent>
        <div className="inline-flex items-center gap-1">
          <ProtocolImage protocol={protocol} className="size-6" />
          <span className="text-base">
            {protocolDisplayName}
            {protocol.version ? ` (${protocol.version})` : ''}
          </span>
        </div>
      </TooltipContent>
    </Tooltip>
  )
}
